import { RESUME_V2_FIELD, SECTIONS_FIELD_V2 } from '@glass/web/modules/resumes/fieldKeys';

import mergeResumes from '@glass/shared/modules/resumes/mergeResumes';

const getResumeInitialValues = ({ activeSection }, ...args) => {
  const merged = mergeResumes({}, ...args);
  if (activeSection) {
    return {
      ...merged,
      [RESUME_V2_FIELD]: {
        ...(merged?.[RESUME_V2_FIELD] || {}),
        [SECTIONS_FIELD_V2]: (merged?.[RESUME_V2_FIELD]?.[SECTIONS_FIELD_V2] || []).map(
          (section) => ({
            ...section,
            hidden: section.type === activeSection ? false : section.hidden,
          }),
        ),
      },
    };
  }
  return merged;
};

export default getResumeInitialValues;
